import { useState } from "react";
import { useCandidates } from "../../contexts/CandidateContext";
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from "@headlessui/react"; 

const CandidateSelector = ({ formData, setFormData }) => {
    const { candidates } = useCandidates();
    const [query, setQuery] = useState("");

    // console.log("list candidates: ", candidates);

    const filteredCandidates = candidates.filter(candidate =>
        candidate.name.toLowerCase().includes(query.toLowerCase())
    );

    const handleSelection = (selectedCandidate) => {
        if (!selectedCandidate) {
            // console.log("Selection cleared");
            setFormData({ ...formData, candidate_id: null });
            return;
        }

        // console.log("Selected candidate: ", selectedCandidate, "selected candidate id", selectedCandidate.id);
        setFormData({ ...formData, candidate_id: selectedCandidate.id });
    };

    return (
        <Combobox value={formData.candidate_id} onChange={handleSelection}>
            <div className="relative">
                <ComboboxInput
                    onChange={(event) => setQuery(event.target.value)}
                    displayValue={(candidateId) => {
                        const selected = candidates.find(c => c.id === candidateId);
                        return selected ? selected.name : "";
                    }}
                    className="w-full p-2 dark:text-white dark:bg-black dark:border-gray-700 border dark:focus:outline-none border-gray-300 rounded"
                    placeholder="Select a candidate"
                    required
                />
                <ComboboxOptions className="absolute w-full dark:bg-black dark:text-white dark:border-gray-700 bg-white border border-gray-300 rounded mt-1 max-h-60 z-20 overflow-auto">
                    {filteredCandidates.length === 0 ? (
                        <div className="p-2 text-gray-500 dark:text-white">No candidates found</div>
                    ) : (
                        filteredCandidates.map((candidate) => (
                            <ComboboxOption key={candidate.id} value={candidate} className="p-2 hover:bg-gray-200 cursor-pointer">
                                {candidate.name}
                            </ComboboxOption>
                        ))
                    )}
                </ComboboxOptions>
            </div>
        </Combobox>
    );
};

export default CandidateSelector;
